import { Col, Row, Tooltip, Modal, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DashboardServices } from "../../redux/Services";
import { UserId } from "../../utils";
import IMAGES from "../../const/Image";
import { usePermission, useRights } from "../../hooks/usePermission";

const HiuDashboard = () => {
  const permission = usePermission("HIU Dashboard", "List");
  // Asking for a report starts a new consent request (needs Add)
  const rights = useRights("HIU Dashboard");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = {
    UserId: UserId,
  };
  const dashboardCounts = useSelector(
    (state) => state.dashboard.HiudashboardCounts || {}
  );
  const { mutate: getHiuDashboardCount } = useMutation((data) =>
    dispatch(DashboardServices.getHiuDashboardCount(data, user))
  );
  const { mutate: fetchgetCardsLogsSearch } = useMutation((data) =>
    dispatch(DashboardServices.fetchgetCardsLogsSearch(data))
  );
  const [askReport, setaskReport] = useState(false);
  const [values, setValues] = useState({
    healthId: "",
  });
  const [noRecord, setNoRecord] = useState(false);
  const { Search } = Input;

  const patientDetail = () => {
    let payload = {
      healthId: values.healthId,
      UserId: UserId,
    };
    fetchgetCardsLogsSearch(payload, {
      onSuccess: (res) => {
        let data = res.data?.result;
        if (data?.length > 0) {
          setNoRecord(false);
          navigate(`/hip/report-detail?healthId=${data[0]?.health_id}`);
        } else {
          setNoRecord(true);
        }
      },
    });
  };

  const handleChange = (name, value) => {
    setValues({ ...values, [name]: value });
  };
  useEffect(() => {
    getHiuDashboardCount({});
  }, []);
  //    console.log(dashboardCounts?.hiu?.HiuFetchConsentDetailsCount)
  return (
    <>
      {" "}
      <h1 className="desk-head"> HIU </h1>
      <Row gutter={[20, 30]}>
        <div className="flex justify-content-end align-items-center pr-10 hiu-dash">
          {rights.Add && (
            <Tooltip title="Ask Report">
              <span className="" onClick={() => setaskReport(true)}>
                <img
                  src={IMAGES.ReqIcon}
                  width={40}
                  height={40}
                  className="cursor-pointer"
                />
              </span>
            </Tooltip>
          )}
        </div>
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hiu-consent-artifact-requested")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Consent Artifact Requested Log{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hiu?.ConsentArtifactRequestCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        {/* <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hiu-consent-grant")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Consent Logs{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hiu?.consentLogsCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col> */}
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hiu-consent-artifact-details")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Consent Artifact Details{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hiu?.ConsentArtifactDetails || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hiu-helath-information-requested")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Health Information Requested{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hiu?.DataRequestSentLog || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hiu/data-received")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Health Information Received{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hiu?.DataReceivedCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        {/* <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hiu/data-request-pending")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Health Information Request Pending{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hiu?.DataRequestPendingCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col> */}
      </Row>
      <Modal
        style={{
          top: 20,
        }}
        open={askReport}
        onOk={() => setaskReport(false)}
        onCancel={() => setaskReport(false)}
        footer={null}
      >
        {/* abha */}
        <Search
          placeholder="ABHA Address"
          allowClear
          enterButton="Search"
          size="large"
          className="askSearch"
          onChange={(e) => handleChange("healthId", e.target.value)}
          onSearch={patientDetail}
          value={values?.healthId}
        />
        {noRecord && <div className="text-center fw-600">No Record Found</div>}
      </Modal>
    </>
  );
};

export default HiuDashboard;
